enum ElyfiVersions {
  V1 = 'v1.0',
}

export default ElyfiVersions
